import { useEffect, useState } from "react";
import { Box, Group, Paper } from "@mantine/core";
import {
  FetchUserAttributesOutput,
  fetchUserAttributes,
} from "aws-amplify/auth";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import Record from "@/components/QuickRecord/Record";
import Recordings from "@/components/QuickRecord/Recordings";
import { useQuickRecordAddCaseStore } from "@/store/quickRecordAddCaseStore";
import { patientsByLIDAndUpdatedAtShallow } from "@/graphql/patientsByLIDAndUpdatedAtShallow";
import {
  ModelSortDirection,
  Patient,
  PatientsByLIDAndUpdatedAtQuery,
  PatientsByLIDAndUpdatedAtQueryVariables,
} from "@/API";

const client = generateClient();

const QuickRecord = () => {
  const [refreshRecordingsAt, setRefreshRecordingsAt] = useState(0);
  const { setPatients } = useQuickRecordAddCaseStore();

  useEffect(() => {
    getPatients();
  }, []);

  async function getPatients() {
    try {
      const userInfo: FetchUserAttributesOutput = await fetchUserAttributes();
      const patientQueryInput: PatientsByLIDAndUpdatedAtQueryVariables = {
        lID: userInfo["custom:location"]!,
        limit: 100,
        sortDirection: ModelSortDirection.DESC,
        filter: {
          _deleted: { ne: true },
        },
      };
      const patientData = await client.graphql<
        GraphQLQuery<PatientsByLIDAndUpdatedAtQuery>
      >({
        query: patientsByLIDAndUpdatedAtShallow,
        variables: patientQueryInput,
      });
      setPatients(
        patientData.data.patientsByLIDAndUpdatedAt!.items!.filter(
          (patient) => patient !== null,
        ) as Patient[],
      );
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  }

  return (
    <Box p={20}>
      <Group w={"100%"} h={"100%"} gap={20} align="flex-start">
        <Paper flex={1} p={0} withBorder shadow="sm">
          <Record onChangeTab={() => setRefreshRecordingsAt(Date.now())} />
        </Paper>
        <Paper flex={1} h={"calc(100vh - 100px)"} p={0} withBorder shadow="sm">
          <Recordings refreshRecordingsAt={refreshRecordingsAt} />
        </Paper>
      </Group>
    </Box>
  );
};

export default QuickRecord;
